import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const RoleBasedRedirect: React.FC = () => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('access_token') : null;
  const userRole = typeof window !== 'undefined' ? localStorage.getItem('userRole') : null;

  // If not authenticated, redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Redirect based on role
  if (userRole === "ADMIN") {
    return <Navigate to="/admin" replace />;
  } else if (userRole === "DOCTOR") {
    return <Navigate to="/dashboard" replace />;
  } else {
    // Unknown role, redirect to login
    return <Navigate to="/login" replace />;
  }
};

export default RoleBasedRedirect;